// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"543":"b6d5e1eb","567":"b6d5e1eb","659":"b6d5e1eb","924":"b6d5e1eb"}[chunkId] + ".chunk.css";
};